import React from 'react'

type Props = {
    theme: string
    purchaseStage: string
    role: string
    isLoading: boolean
    actions: Actions
}

type Actions = {
    update: () => void // Обновить из ЕИС
}

type ButtonConfig = {
    id: string
    label: string
    onClick: () => void
    visibleCondition: boolean // Функция, проверяющая видимость
    className?: string // Стили для кнопки
    iconPathD: string
    iconFill: string
    disabled: boolean
    isLoading: boolean
}

const FooterLeftToolbarButtons: React.FC<Props> = (props) => {
    const isAdmin = props.role === 'admin'
    const isSpecialist = props.role === 'specialist'
    const isCurator = props.role === 'curator'
    const isInitiator = props.role === 'initiator'

    const isExecutionStage = props.purchaseStage !== 'Редактирование'

    const buttons: ButtonConfig[] = [
        {
            id: 'update',
            label: 'Обновить данные из ЕИС',
            onClick: props.actions.update,
            visibleCondition: isExecutionStage && (isAdmin || isSpecialist),
            className: `flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] text-xs ${isExecutionStage ? 'text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40] shadow-md shadow-[#18181830]' : 'text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#EDEDED] dark:bg-[#494849]'}`,
            iconFill: `${props.theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M17.71,11.29l-4-4a1,1,0,1,0-1.42,1.42L14.59,11H3a1,1,0,0,0,0,2H14.59l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76A1,1,0,0,0,17.71,11.29ZM21,4a1,1,0,0,0-1,1V19a1,1,0,0,0,2,0V5A1,1,0,0,0,21,4Z',
            disabled: !isExecutionStage,
            isLoading: props.isLoading,
        },
    ]

    return (
        <>
            {buttons
                .filter((button) => button.visibleCondition) // Оставляем только видимые кнопки
                .map((button, index) => (
                    <button
                        key={index}
                        className={button.className}
                        onClick={button.onClick}
                        disabled={button.disabled}
                    >
                        {button.isLoading ? (
                            <svg
                                className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                ></path>
                            </svg>
                        ) : (
                            ''
                        )}
                        {button.label}
                    </button>
                ))}
        </>
    )
}

export default FooterLeftToolbarButtons
